import { getExtensionFromFileName } from '@lucidlink/uicore';
import { fileAudio, fileDocument, fileImage, fileOther, fileVideo, } from '#assets';
import { audioExtensions, documentExtensions, imageExtensions, videoExtensions, } from '#constants';
export const getFileImageFromName = (fileName) => {
    const extension = getExtensionFromFileName(fileName);
    if (imageExtensions.includes(extension)) {
        return fileImage;
    }
    if (videoExtensions.includes(extension)) {
        return fileVideo;
    }
    if (audioExtensions.includes(extension)) {
        return fileAudio;
    }
    if (documentExtensions.includes(extension)) {
        return fileDocument;
    }
    return fileOther;
};
